var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "348.000000pt",
    height: "348.000000pt",
    viewBox: "0 0 348.000000 348.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,348.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1540 3429 c-316 -36 -633 -167 -880 -364 -311 -249 -518 -581 -607 -979 -36 -164 -43 -414 -14 -586 45 -278 133 -489 299 -725 72 -101 262 -292 369 -370 493 -359 1130 -436 1699 -205 528 215 922 694 1025 1243 105 565 -76 1115 -501 1523 -361 347 -881 521 -1390 463z m-315 -974 c38 -8 98 -24 132 -36 l63 -21 0 -225 0 -225 -55 50 c-81 74 -144 96 -275 97 -93 0 -112 -3 -160 -26 -31 -14 -72 -40 -92 -58 -152 -133 -170 -404 -37 -555 143 -162 408 -168 575 -14 l44 41 0 -226 0 -225 -47 -16 c-127 -40 -181 -50 -288 -49 -170 0 -308 43 -451 141 -79 53 -184 166 -227 244 -65 116 -82 193 -82 363 0 142 2 155 32 238 40 113 83 184 163 270 180 194 456 285 705 232z m776 -24 c3 0 82 -192 175 -426 93 -234 171 -425 174 -425 3 0 82 193 175 428 l171 427 202 0 c111 0 202 -3 202 -8 0 -4 -121 -290 -268 -635 -148 -345 -284 -664 -303 -709 l-34 -82 -150 -1 -150 0 -31 78 c-17 42 -151 362 -298 710 -146 348 -266 636 -266 640 0 6 375 9 401 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.df56e12e805ffab7a69fa39d354a1053.svg";
export { ForwardRef as ReactComponent };